import { doc, setDoc, collection, getDoc, getDocs, writeBatch, deleteDoc, deleteField, updateDoc } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from "firebase/storage";
import { auth, db } from "../../firebase";

export const saveUserLog = async (logType, musicardID, actionType, changedPaths, page) => {
  try {
    const timestamp = new Date().getTime(); // 클라이언트 타임스탬프 사용
    // 경로: /users_logs/{userId}/{logType}/{logId}
    const logDocRef = doc(db, 'users_logs', auth.currentUser.uid, logType, String(timestamp));
    await setDoc(logDocRef, {
      musicardID,
      actionType,
      changedPaths: Array.isArray(changedPaths) ? changedPaths : [changedPaths],
      page,
      timestamp,
    });
    //console.log(`${logType} 로그 저장 성공`);
  } catch (error) {
    console.error(`${logType} 로그 저장 실패:`, error);
  }
};

export const DeleteMusicard = async (card) => {
  // 삭제할 서브컬렉션 구조를 미리 정의합니다.
  const subcollections = [
    { name: 'collaboAlbums', subcollections: ['tracks'] },
    { name: 'contact' },
    { name: 'events' },
    { name: 'members' },
    { name: 'ownAlbums', subcollections: ['tracks'] },
    { name: 'positions', subcollections: ['skills'] },
    { name: 'stages' },
    { name: 'style' },
    { name: 'unreleasedAlbums', subcollections: ['tracks'] },
  ];

  // 각 상위 서브컬렉션을 순회하며 삭제 작업을 수행합니다.
  for (const subColl of subcollections) {
    const topLevelPath = `musicians/${card.id}/${subColl.name}`;
    const topLevelCollectionRef = collection(db, topLevelPath);
    const topLevelSnapshot = await getDocs(topLevelCollectionRef);

    // 상위 서브컬렉션의 각 문서를 처리합니다.
    for (const docSnap of topLevelSnapshot.docs) {
      // 만약 문서에 하위 서브컬렉션이 있다면 먼저 삭제합니다.
      if (subColl.subcollections) {
        for (const nestedName of subColl.subcollections) {
          const nestedPath = `${topLevelPath}/${docSnap.id}/${nestedName}`;
          const nestedCollectionRef = collection(db, nestedPath);
          const nestedSnapshot = await getDocs(nestedCollectionRef);

          // 배치를 사용하여 하위 서브컬렉션 문서를 삭제합니다.
          const nestedBatch = writeBatch(db);
          nestedSnapshot.forEach(nestedDoc => {
            nestedBatch.delete(nestedDoc.ref);
          });
          await nestedBatch.commit();
        }
      }
      // 상위 문서를 삭제합니다.
      await deleteDoc(docSnap.ref);
    }
  }

  // 먼저, 뮤지카드 문서의 gallery 필드를 가져와서 Storage에 저장된 이미지 파일들을 삭제합니다.
  const musicianDocRef = doc(db, "musicians", card.id);
  const musicianDocSnap = await getDoc(musicianDocRef);
  if (musicianDocSnap.exists()) {
    const data = musicianDocSnap.data();
    if (data.gallery && Array.isArray(data.gallery)) {
      const storage = getStorage();
      for (const imageURL of data.gallery) {
        try {
          // 예시 URL:
          // https://firebasestorage.googleapis.com/v0/b/[bucket]/o/users%2F[uid]%2Fgallery%2Ffile.jpg?alt=media&token=...
          const parts = imageURL.split('/o/');
          if (parts.length >= 2) {
            const filePathEncoded = parts[1].split('?')[0]; // query string 제거
            const filePath = decodeURIComponent(filePathEncoded);
            const imageRef = ref(storage, filePath);
            await deleteObject(imageRef);
            //console.log("Storage에서 파일 삭제 성공:", filePath);
          }
        } catch (error) {
          console.error("Storage에서 파일 삭제 오류:", error);
        }
      }
    }
  }
  
  // 마지막으로, musicians/[musicardId] 문서 자체를 삭제합니다.
  await deleteDoc(musicianDocRef);

  await saveUserLog('musicard_logs', card.id, 'delete', `musicians/${card.id}`, 'MusicardPage');


  // ────────────────────────────────────────────────
  // 이제 users_data 아래의 각 컬렉션에서 act 필드를 업데이트합니다.
  // 업데이트할 컬렉션 목록
  const userDataCollections = ["activity", "contact", "members", "positions", "released", "unreleased"];

  // userUid는 뮤지카드와 연관된 사용자의 UID입니다.
  const user = auth.currentUser;
  for (const colName of userDataCollections) {
  const collectionRef = collection(db, "users_data", user.uid, colName);
  const querySnapshot = await getDocs(collectionRef);
  for (const docSnap of querySnapshot.docs) {
    const data = docSnap.data();
    if (data.act) {
    let updateNeeded = false;
    const updates = {};
    // act 객체 내의 각 키에 대해 삭제한 뮤지카드 아이디(card.id)와 일치하는지 확인합니다.
    Object.keys(data.act).forEach(key => {
        if (key === card.id) {
          updates[`act.${key}`] = deleteField();
          updateNeeded = true;
        }
    });
    if (updateNeeded) {
        await updateDoc(doc(db, "users_data", user.uid, colName, docSnap.id), updates);
    }
    }
  }
  }
  // ────────────────────────────────────────────────
  // 이제 /users/[UID]의 musicard 필드에서 해당하는 뮤지카드 값을 삭제합니다.
  const userDocRef = doc(db, "users", user.uid);
  // 먼저 getDoc으로 사용자 문서를 가져옵니다.
  const userDoc = await getDoc(userDocRef);
  if (userDoc.exists()) {
    const userData = userDoc.data();
    if (userData.musicard) {
        let updateNeeded = false;
        const updates = {};
        Object.keys(userData.musicard).forEach(key => {
        if (userData.musicard[key] === card.id) {
            updates[`musicard.${key}`] = deleteField();
            updateNeeded = true;
        }
        });
        if (updateNeeded) {
        await updateDoc(userDocRef, updates);
        }
    }
  }
};  